import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./AdminDashboardUIHelpers";

const AdminDashboardUIContext = createContext();

export function useAdminDashboardUIContext() {
  let scc = useContext(AdminDashboardUIContext);
  return scc;
}

export const AdminDashboardUIConsumer = AdminDashboardUIContext.Consumer;

export function AdminDashboardUIProvider({ customersUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
  };

  return (
    <AdminDashboardUIContext.Provider value={value}>
      {children}
    </AdminDashboardUIContext.Provider>
  );
}
